import { logger } from '../../common/logger';

const regexes = [
  /akamai/, // matches CDN during live playback
  /demdex/, //
  /dax/, // pageload and heartbeat analytics
  /snowplow/, // pageload and event analytics
  /litix/, // mux analytics
];

type ApmTransaction = {
  name: string;
  type: string;
  timestamp: string;
};

type ApmPayload = {
  transactions?: Array<ApmTransaction>;
  errors?: Array<Error>;
};

export const apmRumFilters = (payload: unknown) => {
  try {
    assertPayload(payload);

    if (payload.transactions) {
      payload.transactions = payload.transactions.filter(transaction => {
        for (let i = 0; i < regexes.length; i++) {
          if (regexes[i]?.test(transaction.name)) {
            return false;
          }
        }
        return true;
      });
    }
    return payload.transactions?.length || payload.errors?.length
      ? payload
      : false;
  } catch (err) {
    logger.error({ error: err }, 'apmRumFilters invalid payload');
    return false;
  }
};

export const apmRumIdPlaceholders = (payload: unknown) => {
  try {
    assertPayload(payload);

    if (payload.transactions) {
      for (const transaction of payload.transactions) {
        transaction.name = transaction.name
          .replace(/\b(?:\d{1,2}-[\w-]+)\b/g, ':id')
          .replace(/(deviceToken\/)([\w-]+)/g, '$1:token');
      }
    }

    return payload.transactions?.length || payload.errors?.length
      ? payload
      : false;
  } catch (err) {
    logger.error({ error: err }, 'apmRumIdPlaceholders invalid payload');
    return false;
  }
};

function assertPayload(payload: unknown): asserts payload is ApmPayload {
  if (typeof payload !== 'object' || !payload) {
    throw new Error('Payload is not an object');
  }
  if ('transactions' in payload && !Array.isArray(payload.transactions)) {
    throw new Error('Payload transactions is not an array');
  }
  if ('errors' in payload && !Array.isArray(payload.errors)) {
    throw new Error('Payload errors is not an array');
  }
}
